import React, { useEffect, useState } from 'react';
import {  NavLink } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';
import VisitorCount from './VisitorCount';
import './VisitorCount.css';
import './Header.css';

const Header = () => {
  const [isSticky, setSticky] = useState(false);

  
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 45) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // const { language, setLanguage } = useLanguage();

  // const toggleLanguage = () => {
  //     setLanguage((prevLang) => (prevLang === "en" ? "ar" : "en"));
  // };


  return (
    <>
     <title>مركز نظم المعلومات الجغرافية</title>
    <nav className={`nav-bar ${isSticky ? 'sticky-top shadow-sm' : ''}`}>
   
          <div className="container-fluid topbar px-0 px-lg-4 bg-light py-2  d-lg-block">
              <div className="container">
                  <div className="row gx-0 align-items-center">
                       <div className="col-lg-8 text-center text-lg-start mb-lg-0 text-center">
                         <div className="d-flex flex-wrap text-center">
                            
                              <div className="ps-3">
                                  <a href="mailto:info@gisqatar.org.qa" className="text-muted small"><i className="fas fa-envelope text-primary mx-2"></i>info@gisqatar.org.qa</a>
                              </div>  
                          </div>
                      </div> 
                      <div className="col-lg-4 text-center text-lg-end">
                          <div className="d-flex justify-content-end">
                              <div className="d-flex  pe-3">
                                  <a className="btn p-0 text-primary me-0" href="https://www.facebook.com/p/The-Centre-for-GIS-Ministry-of-Municipality-100064823825358/?paipv=0&eav=AfavVFlCWx2aRExUPHEFIIBwr8qe-gba_h6VeISeVrF8-c0GVTQJfjUWscHpBtmthe8&_rdr" target="_blank" rel="noopener noreferrer"   ><i className="fab fa-facebook-f"></i></a>
                                  <a className="btn p-0 text-primary me-3" href="https://x.com/albaladiya/" target="_blank" rel="noopener noreferrer"  ><i className="fab fa-twitter"  ></i></a>
                                  <a className="btn p-0 text-primary me-3" href="https://www.instagram.com/albaladiya/" target="_blank" rel="noopener noreferrer" ><i className="fab fa-instagram"></i></a>
                                  <a className="btn p-0 text-primary me-3" href="https://www.linkedin.com/company/the-centre-for-gis-state-of-qatar/people/" target="_blank" rel="noopener noreferrer" ><i className="fab fa-linkedin-in"></i></a>
                                  <a className="btn p-0 text-primary me-3" href="https://www.youtube.com/@masouns" target="_blank" rel="noopener noreferrer" ><i className="fab fa-youtube"></i></a>
                                  <div className="d-flex align-items-center">
                                    <VisitorCount />
                                    <LanguageSwitcher />
                                  </div>
                              </div>
                           
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          {/* <!-- Topbar End --> */}
  
          {/* <!-- Navbar & Hero Start --> */}
          <div className="container-fluid nav-bar px-0 px-lg-4 py-lg-0">
              <div className="container" style={{padding:13}}>
                  <nav className="navbar navbar-expand-lg navbar-light"> 
                     
                       
                           <img src= {process.env.PUBLIC_URL + "/asset/en/img/logo.png"} alt="Logo" /> 
                     
                      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                          <span className="fa fa-bars"></span>
                      </button>
                      <div className="collapse navbar-collapse" id="navbarCollapse">
                          <div className="navbar-nav mx-0 mx-lg-auto">
                                                  
                               <NavLink to="/ar/home" className={({ isActive }) => `nav-item nav-link${isActive ? ' active' : ''}`}>
                                  الـرئـيســـة
                               </NavLink>
                               <NavLink to="/ar/about" className={({ isActive }) => `nav-item nav-link${isActive ? ' active' : ''}`}>
                                  حول المركز
                               </NavLink>
                               <NavLink to="/ar/projects" className={({ isActive }) => `nav-item nav-link${isActive ? ' active' : ''}`}>
                                  مشاريع
                               </NavLink>
                               <NavLink to="/ar/services" className={({ isActive }) => `nav-item nav-link${isActive ? ' active' : ''}`}>
                                  خدمات
                               </NavLink>
                               <NavLink to="/ar/products" className={({ isActive }) => `nav-item nav-link${isActive ? ' active' : ''}`}>
                                  منتجات وتطبيقات
                               </NavLink>
                               <NavLink to="/ar/training" className={({ isActive }) => `nav-item nav-link${isActive ? ' active' : ''}`}>
                                  التــدريــب
                               </NavLink>
                               <NavLink to="/ar/news" className={({ isActive }) => `nav-item nav-link${isActive ? ' active' : ''}`}>
                                  الأخبار
                               </NavLink>
                            
                              
                   
                          </div>
                          <div className="d-flex align-items-center">
                            <a
                              href="https://www.gisqatar.org.qa/gportal"
                              className="gov-portal-btn"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <span className="gov-portal-icon-wrapper">
                                <i className="fas fa-landmark" aria-hidden="true"></i>
                              </span>
                              <span>بوابة القطاع الحكومي</span>
                            </a>
                          </div>
                      </div>
                
                  </nav>
              </div>
          </div>
     
    </nav>
    </>
  );
};


export default Header